export const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export const holidays = [
    '2021-11-11',
    '2021-11-25',
    '2022-01-17',
    '2022-02-21',
    '2022-05-30',
    '2022-07-04',
    '2022-09-05',
    '2022-10-10',
    '2022-11-11',
    '2022-11-24',
    '2022-12-26',
    '2023-01-02',
    '2023-01-16',
    '2023-02-20',
    '2023-05-29',
    '2023-07-04',
    '2023-09-04',
    '2023-10-09',
    '2023-11-23',
    '2023-12-25'
];
export const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
